<template>
  <div ref="blockRef" class="mx-auto px-4 max-w-6xl">
    <h2
      v-if="block.title"
      v-html="formatTitle(block.title)"
      :class="`text-[clamp(1.5rem,-0.6818rem+10.9091vw,3.75rem)] leading-none whitespace-nowrap max-w-[41.5rem] ${block.title_color.value}`"
      data-gsap-target="title"
    />

    <div v-if="block.reviews" class="grid gap-6 mt-12 sm:grid-cols-2">
      <div
        v-for="review in block.reviews"
        :key="review.id"
        class="p-6 text-white bg-purple-dark rounded-3xl md:p-12 md:rounded-5xl"
      >
        <div
          v-if="review.quote"
          class="text-lg"
        >
          &ldquo;{{ review.quote }}&rdquo;
        </div>

        <div v-if="review.author || review.company" class="mt-6">
          <div v-if="review.author" class="font-serif font-bold text-lg md:text-xl">
            {{ review.author }}
          </div>

          <div v-if="review.company" class="md:text-lg">
            {{ review.company }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ReviewBlock } from '~/statamic/types/block';

defineProps<{
  block: ReviewBlock;
}>();

let ctx: gsap.Context | null;
const blockRef = ref();

onMounted(() => {
  ctx = useGsap.context((self) => {
    if (typeof self.selector !== 'function') return;

    //
  }, blockRef.value);
});

onUnmounted(() => {
  ctx?.revert();
});
</script>
